import * as React from "react";
const SvgTable = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#B1B1B1"
      d="M21.561 7.855 13.9.323C13.68.108 13.462 0 13.134 0H2.189C.985 0 0 .968 0 2.152v25.825c0 1.184.985 2.153 2.189 2.153H19.7c1.203 0 2.189-.969 2.189-2.153V8.608c0-.322-.11-.538-.329-.753m-8.427-5.272 6.129 6.025h-6.13zM19.7 27.977H2.189V2.152h8.756v6.456c0 1.184.985 2.153 2.189 2.153H19.7z"
    />
    <path fill="#fff" d="M11.531 15.063h13.426v15.495H11.531z" />
    <path
      stroke="#B1B1B1"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.949 19.941c-.158 0-.303.132-.292.287l.146 3.874c0 .038.015.075.043.102a.147.147 0 0 0 .206 0 .142.142 0 0 0 .043-.102l.146-3.874c.01-.155-.134-.287-.292-.287M17.948 26.254a.29.29 0 0 0 .292-.287.29.29 0 0 0-.292-.287.29.29 0 0 0-.292.287c0 .158.13.287.292.287"
    />
    <path
      fill="#B1B1B1"
      d="m26.738 30.524-3.465-3.408a6.53 6.53 0 0 0 1.357-4.67 6.572 6.572 0 0 0-2.258-4.322 6.791 6.791 0 0 0-4.652-1.636 6.778 6.778 0 0 0-4.533 1.932 6.556 6.556 0 0 0-1.965 4.457 6.54 6.54 0 0 0 1.665 4.573 6.761 6.761 0 0 0 4.395 2.22 6.804 6.804 0 0 0 4.75-1.335l3.468 3.41a.878.878 0 0 0 .62.253.89.89 0 0 0 .62-.252.862.862 0 0 0 .258-.61.85.85 0 0 0-.257-.61zM12.985 23.1c0-.965.29-1.908.836-2.71a4.944 4.944 0 0 1 2.226-1.797 5.04 5.04 0 0 1 2.867-.278 4.988 4.988 0 0 1 2.54 1.335 4.854 4.854 0 0 1 1.359 2.498 4.802 4.802 0 0 1-.283 2.818 4.897 4.897 0 0 1-1.827 2.19 5.022 5.022 0 0 1-6.264-.608 4.842 4.842 0 0 1-1.454-3.448"
    />
    <rect
      width={9.469}
      height={1.148}
      x={4.586}
      y={15.063}
      fill="#B1B1B1"
      rx={0.574}
    />
    <rect
      width={6.51}
      height={1.148}
      x={4.586}
      y={17.938}
      fill="#B1B1B1"
      rx={0.574}
    />
  </svg>
);
export default SvgTable;